import createSiteByTemplate from './create-site-by-template';

export default {
  createSiteByTemplate,
};
